import React from 'react';
import { Slider } from 'antd';

import { WithStyle } from './style';

const defaultProps = {};

export default WithStyle((props) => <Slider {...defaultProps} {...props} />);
